import styled from 'styled-components';

import { colors, radius } from '../../styles/tokens';

export const Container = styled.div`
  position: relative;

  span {
    width: 200px;
    background: ${colors.primary};
    padding: 8px;
    border-radius: ${radius.sm};
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    opacity: 0;
    transition: opacity 0.4s;
    visibility: hidden;

    position: absolute;
    bottom: calc(100% + 12px);
    left: 50%;
    transform: translateX(-100%);

    color: ${colors.onPrimary};
  }

  &:hover span {
    opacity: 1;
    visibility: visible;
  }
`;
